import React, { useState, useEffect, useRef } from 'react';
import './fixedbar.css';

const FixedBar = ({top = true, children, className = '', style}) => {
    const [height, setHeight] = useState(0);
    const innerDiv = useRef(null);

    useEffect(() => {
        setHeight(innerDiv.current.getBoundingClientRect().height);
    },[children])

    return (
        <div style = {{ height }}>
            <div className = {`fixedbar ${ top ? 'top' : 'bottom' } ${ className }`} ref = {innerDiv} style = { style }>
                { children }
            </div>
        </div>
    )
}

export default FixedBar;


// WEBPACK FOOTER //
// ./src/components/common/fixedbar.js